import React from 'react';
import PropTypes from 'prop-types';
import { compose, mapProps } from 'recompose';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form/immutable';
import uniq from 'lodash/uniq';
import round from 'lodash/round';
import { List } from 'immutable';

import { bookingsByIds } from '../../../../app/entities/Booking/selectors';
import { withAgreements } from '../../../../app/containers';
import withWorkTypes from '../../../../app/containers/withWorkTypes';
import summarizeTimeplanUnits from '../../../../app/components/Form/Timeplan/summarizeTimeplanUnits';
import requireProps from '../../../../app/lib/requireProps';
import styles from '../styles.css';
import { useTranslation } from 'react-i18next';

function TimeSummary({ summaries }) {
  const { t } = useTranslation();
  return (
    <div className={styles.timeSummaryBox}>
      {summaries.map((summary) => {
        const diffMinutes = round(summary.diffMinutes / 60, 2);

        return (
          <span key={summary.id} className={styles.timeSummary}>
            <span>
              {summary.name} {round(summary.minutes / 60, 2)} h
            </span>
            {diffMinutes !== 0 && (
              <span
                title={t("Skillnad mot bokad tid")}
                className={`badge ${diffMinutes < 0 ?
                  'alert-danger' : 'alert-success'}`}
              >
                {diffMinutes > 0 ? '+' : ''}
                {diffMinutes}h
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}

TimeSummary.propTypes = {
  summaries: PropTypes.instanceOf(List).isRequired,
};

export default compose(
  connect((state, { form }) => ({
    timeplanUnits: formValueSelector(form)(state, 'timeplanUnits'),
  })),
  connect((state, { timeplanUnits, compareTimeplanUnits }) => {
    const bookingsIds = timeplanUnits
      .concat(compareTimeplanUnits)
      .map(({ booking }) => booking)
      .filter(id => !!id);
    const bookings = bookingsByIds(state, bookingsIds);
    const customerAgreementsIds = uniq(bookings
      .map(({ customerAgreement }) => customerAgreement)
      .toJS(),
    );
    return {
      agreementsIds: customerAgreementsIds,
    };
  }),
  withAgreements,
  mapProps(({ agreements, ...props }) => ({
    ...props,
    workTypesIds: agreements ? agreements.reduce(
      (acc, agreement) => acc.push(...agreement.workTypes), new List(),
    ).toSet().toList() : [],
  })),
  withWorkTypes,
  requireProps(['timeplanUnits', 'compareTimeplanUnits']),
  mapProps(({ workTypes, timeplanUnits, compareTimeplanUnits }) => ({
    summaries: summarizeTimeplanUnits(
      workTypes,
      timeplanUnits.toJS(),
      compareTimeplanUnits.map((o) => {
        if (o.toJS) {
          return { ...o.toJS() };
        }
        return o;
      }),
    ),
  })),
  mapProps(({ summaries }) => ({
    summaries: summaries.reduce((newSummaries, summary) => {
      const index = newSummaries.findIndex(({ name }) => name === summary.name);
      if (index === -1) {
        return newSummaries.push(summary);
      }
      const b = newSummaries.get(index);
      return newSummaries.set(
        index,
        {
          id: b.id,
          name: b.name,
          minutes: b.minutes + summary.minutes,
          diffMinutes: b.diffMinutes + summary.diffMinutes,
        },
      );
    }, new List()),
  })),
  // Create summary
)(TimeSummary);
